import React, { useState } from "react";
import { Alert } from "antd";

function AlertNotification({ message, status }) {
  const [visible, setVisible] = useState(true);

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div style={{ position: "absolute", top: "10px", right: "10px" }}>
      <Alert
        message={message}
        type={status ? "success" : "error"}
        showIcon
        style={{ width: "auto" }}
        closable
        afterClose={handleClose}
      />
    </div>
  );
}

export default AlertNotification;
